<template>
  <div
    :class="['layout', _isMobile() ? 'mobile' : '']"
    :style="{
      'background-image': 'url(' + tenantConfig.json_homeBg.image + ')',
      'background-repeat': tenantConfig.json_homeBg.repeat,
      'background-color': tenantConfig.json_homeBg.color,
      'background-size': tenantConfig.json_homeBg.size,
    }"
  >
    <Header2 v-if="tenantConfig.headerType == 2" id="header" />
    <Header3 v-else-if="tenantConfig.headerType == 3" id="header" />
    <Header v-else id="header" />
    <div class="cms">
      <a-row type="flex" :gutter="[24,24]">
        <a-col flex="auto">
            <div class="cms-content">
                <router-view />
            </div>
        </a-col>
        <a-col v-if="tenantConfig.sideContent" flex="300px">
          <div class="cms-side" v-html="tenantConfig.sideContent"></div>
        </a-col>
      </a-row>
    </div>

    <a-back-top />
    <Footer />
  </div>
</template>
  
  <script>
import { mixinDevice } from "@/utils/mixin.js";
import Header from "@/components/header/Header";
import Header2 from "@/components/header/Header2";
import Header3 from "@/components/header/Header3";
import Footer from "@/components/footer/Footer";
export default {
  name: "CmdLayout",
  mixins: [mixinDevice],
  components: {
    Header,
    Header2,
    Header3,
    Footer,
  },
  data() {
    return {
      tenantConfig: {
        sideContent: "",
      },
    };
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo;
  },
};
</script>
  <style>
a * {
  transition: all 0.1s ease;
}
</style>
  <style lang="less" scoped>
.layout {
  background: #f2f6f8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  .cms {
    flex:1 1 auto;
    max-width: 1200px;
    margin: 20px auto 20px;

  }
  .cms-content{
    padding: 20px;
    background: #ffffffd1;
    border-radius: 30px;
  }
  /deep/.ant-list-pagination {
    text-align: center;
  }
  .cms-side {
    width: 300px;
    overflow: hidden;
  }
}
</style>